export default __webpack_public_path__ + "static/3-de25efa3f15adec18b45eaef81bb42a5.jpeg";